import { createRootRoute, redirect } from '@tanstack/react-router';
import { AppLayout } from '../components/layout/AppLayout';
import { getSessionWithRetry } from '../lib/auth-client';

export const Route = createRootRoute({
  beforeLoad: async ({ location }) => {
    const publicPaths = [
      '/login',
      '/register',
      '/forgot-password',
      '/reset-password',
      '/household/invite',
      '/connect/',
      '/open-banking/callback',
      '/privacy',
      '/terms',
    ];
    const isPublic = publicPaths.some((p) => location.pathname.startsWith(p));
    if (isPublic) return;

    const session = await getSessionWithRetry();
    if (!session?.data?.session) {
      throw redirect({ to: '/login' });
    }
  },
  component: RootLayout,
});

function RootLayout() {
  return <AppLayout />;
}
